import React from "react";
import { useDispatch } from "react-redux";

import FiltersDialog from "components/Filters/FiltersDialog";
import { createAllValuesItem } from "components/Filters/helper";
import CheckboxesFilter from "components/Filters/CheckboxesFilter";
import RadioButtonsFilter from "components/Filters/RadioButtonsFilter";
import { IFilterDataItem } from "components/Filters/filtersOptions";
import { setConditionBookFilters } from "store/actions/conditionBookPage";
import {
  defaultConditionBookFiltersState,
  restrictionsFilterData,
  distancesFilterData,
  agesFilterData,
  gendersFilterData
} from "../helper";
import { useStateConditionBookFilters } from "../useStateConditionBookFilters";

interface IProps {
  onClose: () => void;
  conditionsDataFilter: IFilterDataItem[];
}

const ConditionBookFilters = (props: IProps) => {
  const { onClose, conditionsDataFilter } = props;

  const dispatch = useDispatch();
  const {
    selectedRestrictions,
    setSelectedRestrictions,
    selectedDistances,
    setSelectedDistances,
    selectedAge,
    setSelectedAge,
    selectedGender,
    setSelectedGender,
    selectedConditions,
    setSelectedConditions,
    hasChangedFiltersValues,
    hasChangedSavedFiltersValues
  } = useStateConditionBookFilters();

  const handleResetFilters = () => {
    setSelectedRestrictions(
      defaultConditionBookFiltersState.selectedRestrictions
    );
    setSelectedDistances(defaultConditionBookFiltersState.selectedDistances);
    setSelectedAge(defaultConditionBookFiltersState.selectedAge);
    setSelectedGender(defaultConditionBookFiltersState.selectedGender);
    setSelectedConditions(defaultConditionBookFiltersState.selectedConditions);
  };

  const handleApplyFilters = () => {
    dispatch(
      setConditionBookFilters({
        selectedGender,
        selectedDistances,
        selectedAge,
        selectedConditions,
        selectedRestrictions
      })
    );
    onClose();
  };

  return (
    <FiltersDialog
      onClose={onClose}
      onResetFilters={handleResetFilters}
      onApplyFilters={handleApplyFilters}
      disabledResetButton={!hasChangedFiltersValues}
      disabledApplyButton={!hasChangedSavedFiltersValues}
      title="Condition Filter"
      minHeightDialog="100vh"
    >
      <CheckboxesFilter
        title="Restriction"
        data={restrictionsFilterData}
        selectedValues={selectedRestrictions}
        onChangeSelectedValues={setSelectedRestrictions}
        maxWidthPreview={300}
        maxMobileWidthPreview={60}
        withLimit={true}
      />
      <CheckboxesFilter
        title="Distance"
        data={distancesFilterData}
        selectedValues={selectedDistances}
        onChangeSelectedValues={setSelectedDistances}
        maxWidthPreview={300}
        maxMobileWidthPreview={60}
        withLimit={true}
      />
      <CheckboxesFilter
        title="Age"
        data={agesFilterData}
        selectedValues={selectedAge}
        onChangeSelectedValues={setSelectedAge}
        maxWidthPreview={300}
        maxMobileWidthPreview={60}
        withLimit={true}
      />
      <RadioButtonsFilter
        title={"Sex"}
        data={gendersFilterData}
        selectedValue={selectedGender}
        onChangeSelectedValue={setSelectedGender}
      />
      <CheckboxesFilter
        title="Condition"
        data={[createAllValuesItem("Conditions"), ...conditionsDataFilter]}
        selectedValues={selectedConditions}
        onChangeSelectedValues={setSelectedConditions}
        maxWidthPreview={300}
        maxMobileWidthPreview={60}
        withLimit={true}
      />
    </FiltersDialog>
  );
};

export default ConditionBookFilters;
